import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BaseError } from "../../components/pages/base-error";
import { CostView } from "../../models/infix-formula/costView";
import { ClassificationGroupControllerService } from "../../services/classifications-controller/classification-group-controller.service";
import { FormControllerService } from "../../services/form-controller/form-controller.service";
import { CostService } from "../../services/cost-controller/cost.service";

@Component({
  selector: "formula-builder-section",
  templateUrl: "./formula-builder-section.component.html",
  providers: [ToastrService, FormControllerService],
})
export class FormulaBuilderSectionComponent extends BaseError implements OnInit {
  @ViewChild("infixBuilder") public infixFormulaBuilder;

  @Input() public costView: CostView;
  @Input() public formulaIndex: any;
  @Input() public showHeader: boolean = true;
  @Input() public doLoadGroups: boolean = true;
  @Input() public isSubLayer: boolean = false;
  @Input() public isEmbedded: boolean = true;
  @Input() public directSave: boolean = false;

  @Output() public onSave = new EventEmitter();
  @Output() public closeModal = new EventEmitter();
  public jsonLogic: string;
  public filter = "";
  public formulaType: string;
  public serviceId: string;

  constructor(private costService: CostService,
              private route: ActivatedRoute,
              private classificationGroupControllerService: ClassificationGroupControllerService,
              private formControllerService: FormControllerService,
              toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    if (this.costView.formulaType === "determinant" && this.doLoadGroups) { this.loadGroups(); }
    this.formulaType = this.costView.formulaType[0].toUpperCase() + this.costView.formulaType.slice(1);

  }

  public addFormulaToCost(): void {
    this.costView.formula = this.infixFormulaBuilder.saveFormula();
    this.costView.value = true;
    if (this.directSave) {
      this.onSave.emit(this.costView);
    } else {
      this.costService.costView = this.costView;
      this.costService.updateFormula();
    }
  }

  public cancelCostFormula(): void {
    this.costView.value = true;
    this.closeModal.emit(true);
  }

  public setFormula(formula: any) {
    this.costView.formula = formula;
  }

  public loadGroups() {
    this.classificationGroupControllerService.getClassificationsGroups().subscribe(
      (data) => {
        this.costView.properties = [];
        this.costView.groups = data;
        this.costView.groups.forEach((group) => {
          if (!this.costView.properties.find((prop) => prop.id === group.id)) {
            this.costView.properties.push({ id: group.id, name: group.id, label: group.name });
          }
        });
        this.costView.propertiesLoaded = true;
        this.costView.formulaLoaded = true;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public clearCostFormula() {
    this.infixFormulaBuilder.clearFormula();
  }

  public resetDrag() {
    this.infixFormulaBuilder.resetDrag();
  }

  public formulaChange(event) {
    if (!this.directSave) {
      this.onSave.emit(event);
    }
  }
}
